import type { Element } from '../core/constants.ts';

/**
 * What each school looks like, shared by everything that draws one.
 *
 * Lifted out of `actors.ts` because the spell effects need exactly the same
 * answer and two copies of a colour table is two colour tables that drift.
 * These are the only saturated things on screen by design: the arena is graded
 * muted and low in value so that a spell crossing it is unmistakably a spell.
 */
export const ELEMENT_COLOR: Record<Element, number> = {
  fire: 0xff6a1f,
  cold: 0x7fd8ff,
  earth: 0xb08658,
  light: 0xfff2a8,
  void: 0x8a4fd8,
  mana: 0x4f8ad8,
  physical: 0xd8d2c4,
};
